export const DEFAULT_DURATION = 5000;
export const WINNER_LIST_DEFAULT_COLOR = '#ECECEC';
export const WINNER_LIST_TOP_WINNERS_COLOR = '#FFD43A';
export const NUMBER_OF_HIGHLIGHTED_WINNERS = 3;
export const MOBILE_MULTI_ROW_MAX_NUMBER_OF_WINNERS_PER_SECOND = 2;
export const WINNER_USERNAME_BREAKPOINT = 15;
export const WINNER_LIST_ITEM_DISPLAY_TIMER = 1000;
export const WINNER_LIST_ROW_HEIGHT = 30;
export const WINNER_LIST_INDEX = 'winner_list_index';
